import {React, styled} from 'common'
import {Colors, Texts} from 'appearance'
import PageHeader from 'components/Page/PageHeader'
import SideMenu from 'components/Page/SideMenu'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import SideMenuDrawerHeader from './SideMenu/SideMenuDrawerHeader'
import {SIDE_MENU_ANIMATION_DURATION} from 'appearance/styles'
import UsePage from 'logic/Page/UsePage'
import {MobileView} from 'react-device-detect'

const Page = ({
    title,
    children,
    noHeader,
    noDrawer,
    background,
    isSearchLoading,
}) => {
    const {drawerOpen, toggleDrawer, closeDrawer, dir, marginStart} = UsePage({
        noDrawer,
    })

    return (
        <Container dir={dir} background={background}>
            <CssBaseline />
            {!noHeader && (
                <PageHeader
                    toggleDrawer={toggleDrawer}
                    open={drawerOpen}
                    isSearchLoading={isSearchLoading}
                />
            )}
            {!noDrawer && (
                <SideMenu
                    open={drawerOpen}
                    handleClose={closeDrawer}
                    toggleDrawer={toggleDrawer}
                />
            )}
            <Content
                component="main"
                marginStart={marginStart}
                noDrawer={noDrawer}
                noHeader={noHeader}>
                <SideMenuDrawerHeader />
                <MobileView>
                    <SideMenuDrawerHeader />
                </MobileView>
                <Title>{title}</Title>
                {children}
            </Content>
        </Container>
    )
}

export default Page

const Container = styled(Box)`
    min-height: 100vh;
    background-color: ${({background}) => background ?? Colors.APP_GRAY_LIGHT};
    align-items: center;
    padding-top: 10px;
`

const Content = styled(Box)`
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: ${(p) => (p.noHeader ? 'center' : 'flex-start')};
    @media (min-width: 600px) {
        margin-inline-start: ${(p) => p.marginStart}px;
    }
    transition: all ${SIDE_MENU_ANIMATION_DURATION}ms;
`
const Title = styled(Texts.Title)``
